<ng-container *ngIf="showInstallments && installmentsAmount >= thresholdPrice">
  <div class="installments-container"
    data-pp-message
    [attr.data-pp-amount]="installmentsAmount">
  </div>
</ng-container>
